
import Card from '../components/base/Card';
import Button from '../components/base/Button';

export default function Services() {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Limpieza Residencial',
      features: [
        'Limpieza semanal, quincenal o mensual',
        'Cocinas, baños y áreas comunes',
        'Aspirado y trapeado de pisos'
      ],
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20modern%20residential%20home%20interior%20being%20professionally%20cleaned%2C%20sparkling%20clean%20kitchen%20and%20living%20room%2C%20natural%20lighting%2C%20contemporary%20furniture%2C%20spotless%20surfaces%2C%20professional%20cleaning%20equipment%20visible%2C%20warm%20and%20inviting%20atmosphere&width=400&height=300&seq=residential&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: 'Limpieza Comercial',
      features: [
        'Oficinas y espacios de trabajo',
        'Limpieza nocturna disponible',
        'Mantenimiento de áreas comunes'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20office%20space%20being%20cleaned%2C%20modern%20corporate%20environment%2C%20clean%20desks%20and%20workstations%2C%20polished%20floors%2C%20bright%20lighting%2C%20business%20atmosphere%2C%20cleaning%20supplies%20and%20equipment%2C%20pristine%20commercial%20interior&width=400&height=300&seq=commercial&orientation=landscape'
    },
    {
      icon: 'ri-brush-line',
      title: 'Limpieza Profunda',
      features: [
        'Limpieza detallada de toda la casa',
        'Electrodomésticos por dentro y fuera',
        'Ventanas, zócalos y rincones'
      ],
      image: 'https://readdy.ai/api/search-image?query=Deep%20cleaning%20service%20in%20action%2C%20detailed%20cleaning%20of%20appliances%20and%20hard-to-reach%20areas%2C%20professional%20cleaners%20working%20thoroughly%2C%20sparkling%20clean%20results%2C%20before%20and%20after%20transformation%2C%20intensive%20cleaning%20process&width=400&height=300&seq=deep-clean&orientation=landscape'
    },
    {
      icon: 'ri-truck-line',
      title: 'Move-in/Move-out',
      features: [
        'Preparación para nuevos inquilinos',
        'Limpieza completa post-mudanza',
        'Garantía de depósito recuperado'
      ],
      image: 'https://readdy.ai/api/search-image?query=Empty%20house%20being%20professionally%20cleaned%20for%20move-in%20or%20move-out%2C%20spotless%20vacant%20rooms%2C%20clean%20walls%20and%20floors%2C%20moving%20boxes%20in%20background%2C%20fresh%20start%20atmosphere%2C%20thorough%20cleaning%20service&width=400&height=300&seq=move-clean&orientation=landscape'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Post-construcción',
      features: [
        'Remoción de polvo y residuos',
        'Limpieza de ventanas y superficies',
        'Preparación para ocupación'
      ],
      image: 'https://readdy.ai/api/search-image?query=Post-construction%20cleaning%20service%2C%20newly%20built%20or%20renovated%20space%20being%20cleaned%2C%20removal%20of%20construction%20dust%20and%20debris%2C%20professional%20cleaning%20of%20new%20surfaces%2C%20pristine%20finished%20interior%20ready%20for%20occupancy&width=400&height=300&seq=construction&orientation=landscape'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-friendly',
      features: [
        'Productos 100% naturales y seguros',
        'Sin químicos tóxicos',
        'Seguro para niños y mascotas'
      ],
      image: 'https://readdy.ai/api/search-image?query=Eco-friendly%20cleaning%20products%20and%20natural%20cleaning%20supplies%2C%20green%20cleaning%20solutions%2C%20organic%20cleaning%20materials%2C%20environmentally%20safe%20products%2C%20natural%20ingredients%2C%20sustainable%20cleaning%20approach&width=400&height=300&seq=eco-friendly&orientation=landscape'
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 font-outfit">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto font-inter">
            Ofrecemos una amplia gama de servicios de limpieza profesional 
            adaptados a tus necesidades específicas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} hover className="h-full flex flex-col">
              <div className="mb-6">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-48 object-cover object-top rounded-lg mb-4"
                  loading="lazy"
                />
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center">
                    <i className={`${service.icon} text-sky-500 text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 font-outfit">
                    {service.title}
                  </h3>
                </div>
              </div>
              
              <div className="flex-grow">
                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start gap-3">
                      <i className="ri-check-line text-emerald-500 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-slate-600 font-inter">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <Button 
                variant="outline" 
                onClick={scrollToContact}
                className="w-full mt-auto"
              >
                Solicitar cotización
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
